import { App as AntdApp } from 'antd';
import { setRequestNotificationApi } from 'libs/sdk/src/lib/request/request-notification';
import { useEffect } from 'react';

import { setAppMessageApi } from '@/services/antd-message';

export const MessageHandler = () => {
  const { message: messageApi, notification: notificationApi } = AntdApp.useApp();

  useEffect(() => {
    setAppMessageApi(messageApi);
    setRequestNotificationApi(notificationApi);
  }, [messageApi, notificationApi]);

  return null;
};
